import { selector } from 'recoil'

const fetchUsers = selector({
  key: 'fetch_all_users',
  get: async ({ get }) => {
    const response = await fetch('https://jsonplaceholder.typicode.com/users')
    const data = response.json()
    return data
  }
})

export default fetchUsers
